module.exports = __webpack_public_path__ + "static/media/socialPiper-schedule-desktop-es.8bce8313.png";